import { defineComponent as _defineComponent } from 'vue'
import { IEventEdit } from '@/enitites/event'
import { useEventPayoutAccountQuery } from '@/features/payoutAccounts/api/queries'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventBankAccount',
  props: {
    eventData: null
  },
  setup(__props: any) {

const props = __props as {
  eventData: IEventEdit
};



const { data: eventAccountData, isLoading: eventAccountLoading } = useEventPayoutAccountQuery(props.eventData.id)

return { __sfc: true,props, eventAccountData, eventAccountLoading }
}

})